/**
 * Mandatory max-session policy defaults.
 *
 * Runtime overrides: apps read `VITE_MANDATORY_SESSION_*` (and existing
 * `VITE_MANDATORY_RELOGIN_*` for base max / warning) from their environment
 * and pass values into `MandatoryReloginManager` and `useMandatoryReloginRemainingMs`.
 */

/** Minutes added to the effective max session each time the user extends. */
export const MANDATORY_SESSION_EXTENSION_SLOT_MINUTES = 10

/** Max number of extensions after the base window. */
export const MANDATORY_SESSION_MAX_EXTENSIONS = 2

/**
 * Upper bound Redux accepts for `maxSessionExtensionCount` (guardrail only; UI/env should stay ≤ product max).
 */
export const MANDATORY_SESSION_EXTENSION_COUNT_REDUX_CEILING = 24

export function mandatorySessionExtensionSlotMs(
  slotMinutes: number = MANDATORY_SESSION_EXTENSION_SLOT_MINUTES
): number {
  return Math.max(1, Math.floor(slotMinutes)) * 60 * 1000
}
